import { render } from "./study_list.vue?vue&type=template&id=393acdf8&scoped=true"
import script from "./studyListComponent.js?vue&type=script&lang=js"
export * from "./studyListComponent.js?vue&type=script&lang=js"

import "./study_list.vue?vue&type=style&index=0&id=393acdf8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393acdf8"]])

export default __exports__